module.exports = "\r\n<i class=\"icon-user\"></i>\r\n<div class=\"name-user\">{{name}}</div>"